import ABRCodeData from 'Data/ABRCodeData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import BOSFilterSelect from './index';

let DM = new DataManager();

const ABRCodeSelect = ({
  onSelectABRCode,
  defaultSelectedABR,
  labelText = 'ABR Code...',
}) => {
  const [abrCodeList, setAbrCodeList] = useState([]);

  useEffect(() => {
    DM.add(
      ABRCodeData.registerListener('ALL_ABR_CODES_LOADED', onAbrListLoaded),
      ABRCodeData,
    );
  }, []);

  useEffect(() => {
    let abrList = ABRCodeData.getAllABRCodes();
    if (abrList) {
      setAbrCodeList(abrList);
    }
  }, []);

  const onAbrListLoaded = (payload) => {
    if (payload) {
      setAbrCodeList(payload.records);
    }
  };

  return (
    <BOSFilterSelect
      listData={abrCodeList}
      idField={'abr_code'}
      labelFunction={(abr) => {
        return `${abr.abr_code} ${abr.description}`;
      }}
      searchFunction={(abr) => {
        return `${abr.abr_code} ${abr.description}`;
      }}
      defaultSelectedId={defaultSelectedABR}
      onItemSelect={onSelectABRCode}
      placeholder={labelText}
    />
  );
};

ABRCodeSelect.propTypes = {
  onSelectABRCode: PropTypes.func,
  defaultSelectedABR: PropTypes.string,
  labelText: PropTypes.string,
};

export default ABRCodeSelect;
